import {
    ANNOTATION_VIDEO_DISPLAY,
    // ANNOTATION_PARENT,
    VIDEO_PLAYING_MODE,
    // ANNOTATION_LOCATION,
    // VIDEO_SRC_TYPE
} from './GlobalConstants';
import * as THREE from "three";
// import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/silk-road%2Fsilk-along-sr-2023%2F";
export const ANNOTATION_TEXT_ALIGNMENT = "justify";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
export const GALLERY_LINK_LABEL = "TROUBLESHOOTING";

const INFO_TAG = '/assets/sprites/project_sprites/Info.svg';


const AnnotationsDB = [

    /* PERMANENT MATERIAL */
    /* AUDIO */
    {
        paintingId: 'NANINTA083',
        videoId: 'NANINTA083',
        standaloneVideoElementId: 'NANINTA083',
        videoURL: 'NANINTA083.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
    },
    /* AUDIO */
    /* VIDEO */
    {
        paintingId: 'NANINTV083',
        videoId: 'NANINTV083',
        standaloneVideoElementId: 'NANINTV083',
        videoURL: 'NANINTV083.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },

    {
        paintingId: 'RTG_RTG_V223',
        videoId: 'RTG_RTG_V223',
        standaloneVideoElementId: 'RTG_RTG_V223',
        videoURL: 'RTG_RTG_V223.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '',
        bodyText: `Silk Weaving. Attributed to Cheng Qi (傳)程棨 (active mid- to late 13th century)`,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    /* VIDEO */

    /* TEXT ANNOTATIONS */
    /* Extras */
    {
        paintingId: "NANINTL124",
        videoId: "",
        videoURL: "",
        isMediaUsed: "N",
        headerText: "<h5>Sponsors</h5>",
        bodyText: `Blue Ninja: <u>https://blueninja.eu/</u><br>IIAS: <u>https://www.iias.asia/</u><br> New Silk Roads: <u>https://newsilkroads.info/</u>`,
        displayMesh: "N",
        useMeshButton: "N",
        urlLink2Label: "BlueNinja",
        urlLink2: "https://blueninja.eu/",
        urlLink3Label: "IIAS",
        urlLink3: "https://www.iias.asia/",
        urlLink1Label: "NSR",
        urlLink1: "https://newsilkroads.info/",
        spriteImageURL: INFO_TAG,
        annotation_location_vert_offset: 0.22,
        annotation_location_horiz_offset: -0.12,
        // annotation_location_z_offset: 1,
    },
    {
        paintingId: "VENSRM_T072",
        videoId: "",
        videoURL: "",
        isMediaUsed: "N",
        headerText: "<h6>Silk Road Virtual Museum 1200-1450</h6>",
        bodyText: "Welcome to the Silk Road Virtual Museum. The museum is designed to portray the art and culture of the societies that spanned the area between Asia and Europe.<br><br>The first period covered by the Museum is that between 1200 and 1450CE. This is seen by historians as the last period of overland trade and cultural exchange. It also witnessed the first Chinese diplomatic voyages that reached the Red Sea and the coast of West Africa. Gradually the period will be rolled backward to earlier epochs.<br><br>" + "Thus far the museum has been forming a network of city locations: each chosen to represent a particular culture. This museum breaks that pattern by covering one thousand years of history and ten thousand kilometres of trade routes. It tells the story of silk, the product that is associated with the trade networks spanning the Eurasian land mass – better known as ‘the silk road’." + "<br><br>Further information and eLibraries are available at:",
        displayMesh: "N",
        useMeshButton: "Y",
        urlLink1Label: "Silk Road VM-I",
        urlLink1: "https://silkroadvirtualmuseum.com/",
        urlLink2Label: "Silk Road VM-II",
        urlLink2: "https://silkroadvm.com/",
        spriteImageURL: INFO_TAG,
        annotation_location_vert_offset: -0.05,
        annotation_location_horiz_offset: -0.04,
        // annotation_location_z_offset: 1,
    },
    {
        paintingId: "NANDEPW127",
        videoId: "",
        videoURL: "",
        isMediaUsed: "N",
        headerText: `<h6>Silk Road Virtual Museum</h6>`,
        bodyText: `Thank-you for visiting the museum. If you would like to give us your feedback, to offer to help, to make a donation or to sign up for our newsletter, please click BELOW`,
        displayMesh: "Y",
        useMeshButton: "Y",
        urlLink1Label: "Silk Road Virtual Museum",
        urlLink1: "https://silkroadvirtualmuseum.com/landing/",
    },
    /* Extras */
    /* TEXT ANNOTATIONS */
    /* PERMANENT MATERIAL */

    /* INFORMATION DESK */
    {
        paintingId: "SID_SID_B208",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/77ktNSPFbwQ',
        headerText: `<h6>How silkworms make silk</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "SID_SID_B209",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/cgavTIBQ_Z0',
        headerText: `<h6>How silkworms make silk<br>(a deeper look)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "SID_SID_B210",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/xyyQzyvJkgg',
        headerText: `<h6>How to make Silk Brocade</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "SID_SID_B211",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/CVOxVETEX_4',
        headerText: `<h6>A Brocade loom at work</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "SID_SID_B212",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/0I-993CMJyE',
        headerText: `<h6>Historical Fashion in China<br>(475 BC-AD1279)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "SID_SID_B213",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/lef3usLEnO8',
        // iframeSource: 'https://www.youtube.com/watch?v=lef3usLEnO8',
        headerText: `<h6>How did fashion differ in the Tang<br>Song and Ming dynasties?</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "SID_SID_B214",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/Qr-YDpbO4zA',
        headerText: `<h6>Tang dynasty fashion<br>(in Chinese)</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "SID_SID_B215",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/xxpCL-hVp08',
        headerText: `<h6>Women’s fashion in<br>the Tang dynasty</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    {
        paintingId: "SID_SID_B216",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/uO4L-mkjzis',
        headerText: `<h6>Women’s fashion in<br>the Song dynasty</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
    },
    /* INFORMATION DESK */

    {
        paintingId: "RTG_RTG_V224",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/ccvEitq8cFY',
        headerText: `<h6></h6>`,
        bodyText: `Silk Weaving. Attributed to Cheng Qi (傳)程棨 (active mid- to late 13th century)`,
        displayMesh: "Y",
        useMeshButton: "Y",
    },

    {
        paintingId: "RTG_RTG_M229",
        videoId: "",
        videoURL: "",
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_01.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_02.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_03.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_04.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_05.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_06.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_07.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_08.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_10.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_11.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}RTG_RTG_M229_12.jpg/info.json`
        ],
        headerText: null,
        bodyText: `Note that Chinese books go from right to left`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotation_location_horiz_offset: -0.1,
        // annotation_location_vert_offset: -0.06,
    },

    /* AUDIO */
    // {
    //     paintingId: 'ARM_CAD_A001_ARM',
    //     videoId: 'ARM_CAD_A001_ARM',
    //     standaloneVideoElementId: 'ARM_CAD_A001_ARM',
    //     videoURL: 'ARM_CAD_A001_ARM.mp3',
    //     displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
    //     headerText: '',
    //     bodyText: null,
    //     displayMesh: 'Y',
    //     useVideoMeshButton: 'Y',
    //     displayHeight: 90,
    //     videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
    //     displayAudioSprite: 'N',
    //     videoLoop: false,
    //     videoAutoPlayDelay: 0,
    // },
    /* AUDIO */

    /* IMAGE ANNOTATIONS */
    // {
    //     paintingId: "SAT_R01_P002",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P002.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 92 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P003",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P003.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 115 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P004",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P004.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P005",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SAT_R01_P005.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P006.jpg/info.json`],
    //     headerText: null,
    //     bodyText: `Length: 125 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P007",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P007.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P008",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P008.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 146 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P009",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P009.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 140 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P010",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P010.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 71 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P011",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SAT_R01_P011.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P012.jpg/info.json`],
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P013",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P013.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P014",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P014.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 76.8 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P015",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SAT_R01_P015.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P016.jpg/info.json`],
    //     headerText: null,
    //     bodyText: `Length: 48 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P017",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SAT_R01_P017.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P018.jpg/info.json`],
    //     headerText: null,
    //     bodyText: `Length: 144.8 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P019",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P019.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 140 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P020",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P020.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 133 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P021",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P021.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R01_P022",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SAT_R01_P022.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}SAT_R01_P023.jpg/info.json`],
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P025",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P025.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 150 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P026",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P026.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 151.1 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P027",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P027.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 127 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P028",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P028.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P029",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P029.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 124 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P030",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P030.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P031",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P031.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 120 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P032",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P032.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P033",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P033.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 125 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P034",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P034.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 145 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P035",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P035.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 69 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P036",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P036.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 58 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P037",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P037.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 62 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P038",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SAT_R02_P038.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P039.jpg/info.json`],
    //     headerText: null,
    //     bodyText: `Length: 142 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P040",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P040.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 126 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P041",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P041.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 123 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P042",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P042.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 142 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P043",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P043.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P044",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P044.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 140 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P045",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P045.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 158 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P046",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P046.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P047",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SAT_R02_P047.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P048.jpg/info.json`],
    //     headerText: null,
    //     bodyText: `Length: 130 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P049",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P049.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 142 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P050",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P050.jpg/info.json`,
    //     headerText: null,
    //     bodyText: `Length: 148 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P051",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P051.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P052",
    //     videoId: "",
    //     videoURL: "",
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SAT_R02_P052.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P053.jpg/info.json`],
    //     headerText: null,
    //     bodyText: `Length: 120 cm`,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // {
    //     paintingId: "SAT_R02_P054",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}SAT_R02_P054.jpg/info.json`,
    //     headerText: null,
    //     bodyText: null,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotation_location_horiz_offset: -0.1,
    //     // annotation_location_vert_offset: -0.06,
    // },
    // // {
    // //     paintingId: "",
    // //     videoId: "",
    // //     videoURL: "",
    // //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    // //     headerText: null,
    // //     bodyText: null,
    // //     displayMesh: "Y",
    // //     useMeshButton: "N",
    // //     // annotation_location_horiz_offset: -0.1,
    // //     // annotation_location_vert_offset: -0.06,
    // // },
    // // {
    // //     paintingId: "",
    // //     videoId: "",
    // //     videoURL: "",
    // //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    // //     headerText: null,
    // //     bodyText: null,
    // //     displayMesh: "Y",
    // //     useMeshButton: "N",
    // //     // annotation_location_horiz_offset: -0.1,
    // //     // annotation_location_vert_offset: -0.06,
    // // },
    /* IMAGE ANNOTATIONS */


];

export {AnnotationsDB};
